export default __webpack_public_path__ + "static/media/contact_location.e628bd65.png";